import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import * as Icon from 'react-feather';
import React from 'react';
import { setCheckout } from '../../../../redux/store/store.actions';
import LazyImage from '../../lazyload/lazy-image/lazy-image.component';
import Toggle from 'react-toggle';
import { config } from '../../../../configs/app.config';

const SelectRelevo = ({
  checkout,
  me,

  setCheckout,
}) => {
  return (
    ['dev', 'demo'].includes(config.env) &&
    [
      '432ec238-cc57-452d-9845-0ddde4cdeaf3', // Admir@dev
      '62a75f88-eb4f-4c11-b9de-f66fd34a7b41', // Benedikt@demo
      '72aefc7c-db93-4a8f-8306-7f2ac25386ac', // Daniel@demo
      'f1021e1b-1e2f-4d3e-8958-8bd497033e1d', // Adis@local-dev
      'f1b13d93-5084-47be-a042-035e713edf94', // Adis@demo
    ].includes(me?.requester?.customerProfile?.id) && (
      <>
        <LazyImage
          src={'/assets/logos/relevo-logo.png'} // compare explicitly to null => coverImage was not set
          className="thumbnail-h25"
          placeholderContainerClassNames="thumbnail-h25"
          placeholderClassNames="thumbnail-h25"
        />
        <div className="d-flex align-items-center justify-content-between mt-50">
          <span className="mr-1">
            <FormattedMessage id="cartRelevoTitle" />
          </span>
          <label
            className="d-flex react-toggle-wrapper"
            onClick={(e) => e.stopPropagation()}
          >
            <Toggle
              defaultChecked={checkout?.useRelevo || false}
              onClick={(e) => setCheckout({ useRelevo: e.target.checked })}
              name="switch"
              value="yes"
              disabled={false}
              icons={{
                checked: (
                  <Icon.Check
                    size={13}
                    style={{
                      position: 'absolute',
                      top: '-2px',
                      left: '2px',
                    }}
                    color="white"
                  />
                ),
                unchecked: (
                  <Icon.X
                    size={13}
                    style={{
                      position: 'absolute',
                      top: '-2px',
                      right: '-2px',
                    }}
                  />
                ),
              }}
            />
          </label>
        </div>
        <span className="font-small-2 mt-50">
          <FormattedMessage
            id="cartRelevoText"
            values={{
              agb_link: (text) => (
                <a
                  href="https://relevo.de/agb/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {text}
                </a>
              ),
            }}
          />
        </span>
        <hr />
      </>
    )
  );
};

const mapStateToProps = (state) => ({
  checkout: state.store.checkout,
  me: state.me.me,
});

export default connect(mapStateToProps, {
  setCheckout,
})(SelectRelevo);
